import request from '@/api/config/request'

const prex = "api/admin/gestao/duams_emitidas";

export function listDuamsEmitidas(query = {}) {
    return request({
        url: `${prex}`,
        method: 'get',
        params: query
    })
}

export function duamAlterar(data) {
    return request({
        url: `${prex}/alterar`,
        method: 'post',
        data
    })
}

export function duamBaixaManual(data) {
    return request({
        url: `${prex}/baixa`,
        method: 'post',
        data
    })
}